import loadData from './load-data';
import core_viz from './core-viz';
import love_hate from './love-hate';
import love_hate_steps from './love-hate-steps';
import track from './track';
import comm from './community';
import routine from './routine';
import health_globe from './health-globe';
import health_bars from './health-bars';
import comm_bars from './community-bars';
import aspirations from './aspirations';
import graphic from './graphic';
import lang from './lang';
import filters from './filters';
import header from './header';
import menu from './menu';

// let current_chapter = 'love-hate',
let current_chapter = 'landing',
	current_index = 0,
	current_doc = null;

let set_timeout = null;

function athletePanelUpdate(athlete, doc) {
	const panel = d3.select('.graphic__right.athletes').select('.rp__content')
	const main = panel.select('.rp__content--main'),
		wrapper = main.select('.rp__content--main__wrapper'),
		footer = panel.select('.rp__content--footer');

	$('.graphic__right').scrollTop(0);

	let content = parseContent(doc.aspirations.athletes.filter(d => d.name == athlete)[0]);

	wrapper.classed('is-visible', false).classed('is-past', false);

	setTimeout(() => {
		wrapper.classed('is-visible', true).classed('is-past', false);
	}, 1)

	main.select('h1').html(content.name);
	main.select('h2').html('');
	main.select('.prose').html('');
	// footer.html('');

	content.title.forEach(d => {
		main.select('h2').append('span').attr('class', `lang lang--${d.lang}`).html(d.text);
	});

	content.bio.forEach(d => {
		main.select('.prose').append('span').attr('class', `lang lang--${d.lang}`).html(d.text);
	});

	footer.selectAll('.rp__content--footer__button').style('display', 'flex');
	footer.select(`[data-athlete='${athlete}']`).style('display', 'none');

	footer.selectAll('.athlete-select').on('click', function() {
		const athlete = d3.select(this).attr('data-athlete');
		showAthlete(athlete, doc);
	});

	panel.select('.close-button').on('click', () => {
		hideAthletes();
	})

	lang.init();
}

function rightPanelUpdate(container, panel, chapter, doc) {
	const header = panel.select('.rp__content--header'),
		main = panel.select('.rp__content--main'),
		wrapper = main.select('.rp__content--main__wrapper'),
		footer = container.select('.rp__content--footer');

	wrapper.classed('is-visible', false).classed('is-past', false);

	setTimeout(() => {
		wrapper.classed('is-visible', true).classed('is-past', false);
	}, 1)

	current_doc = doc;
	current_index = +panel.attr('data-index');
	current_chapter = chapter;

	let next = current_index + 1,
		content = parseContent(doc[chapter].steps[current_index]);

	panel.attr('data-index', next);

	main.select('h1').html('');
	main.select('.prose').html('');

	content.hed.forEach(d => {
		// main.select('h1').append('span').attr('class', `lang lang--${d.lang}`).html(d.text).classed('font-size-adjust', (d.lang == 'de-DE' && ((chapter == 'core-viz' && current_index == 0) || (chapter == 'health' && current_index == 1) || (chapter == 'health' && current_index == 2) || (chapter == 'routine' && current_index == 2) || (chapter == 'community' && current_index == 1))) || (d.lang == 'fr-FR' && ((chapter == 'core-viz' && current_index == 0) || (d.lang == 'fr-FR' && ((chapter == 'core-viz' && current_index == 1))) || (d.lang == 'fr-FR' && ((chapter == 'community'))))) || (d.lang == 'es-ES' && ((chapter == 'core-viz' && current_index == 0) || (d.lang == 'es-ES' && ((chapter == 'core-viz' && current_index == 1))))));

		main.select('h1').append('span').attr('class', `lang lang--${d.lang}`).html(d.text).classed('font-size-adjust', (d.lang == 'de-DE') || (d.lang == 'fr-FR') || (d.lang == 'es-ES') || (d.lang == 'ja-JP' && (chapter == 'community')) || (d.lang == 'pt-BR'));
	})

	content.text.forEach(d => {
		d.text.forEach(s => {
			main.select('.prose').append('p').attr('class', `lang lang--${d.lang}`).html(s.value);
		})
	});

	if (content.instructions) {
		content.instructions.forEach(d => {
			main.select('.prose').append('p').attr('class', `instructions lang lang--${d.lang}`).html(d.text);
		})
	}

	if (content.prev) {
		footer.select('.footer-nav').classed('is-visible', true);
	}

	footer.select('.dir-back-cv').classed('is-visible', content.backToCV);
	footer.select('.dir-back').classed('is-visible', content.prev);
	footer.select('.dir-forward').classed('is-visible', content.next);
	footer.select('.dir-forward .footer__button--dir').classed('is-visible', content.next);
	footer.select('.footer-nav').classed('is-visible', true);
	footer.select('.footer__button--next-chapter').classed('is-visible', content.next_chapter);

	if (content.next_chapter) {
		footer.select('.footer__button--next-chapter').select('.footer__button--next__main').html('');

		content.button.forEach(d => {
			footer.select('.footer__button--next-chapter').select('.footer__button--next__main').append('span').attr('class', `lang lang--${d.lang}`).html(d.text);
		});
	}

	if (content.next) {
		footer.select('.footer__button--next__main').html('');

		content.button.forEach(d => {
			footer.select('.footer__button--next__main').append('span').attr('class', `lang lang--${d.lang}`).html(d.text);
		});
	}

	main.selectAll('.chapter-contents').classed('is-visible', content.chapters);

	main.selectAll('.athlete-select').classed('is-visible', content['featured-athletes']);

	footer.selectAll('.footer-contents').classed('is-visible', content.button == 'chapters' ? true : false);

	if (content['featured-athletes']) {
		main.selectAll('.athlete-select').on('click', function() {
			const athlete = d3.select(this).attr('data-athlete');
			showAthlete(athlete, doc);
		});
	}

	footer.select('.footer__button--next-chapter').on('click', () => {
		// current_chapter = chapter;
		current_index = 0;

		current_chapter = chapter;

		if (chapter == 'core-viz') {
			// showChapter('health');
			// filters.toggle('health', -1);
			// transitionViz('health');
			menu.chapterChange('health');
		}

		if (chapter == 'community') {
			comm.end();
			comm_bars.end();
			showChapter('aspirations');
			filters.toggle('aspirations', -1);
			transitionViz('aspirations')
		}

		if (chapter == 'health') {
			transitionViz('routine');
			// health_globe.clear();
			// current_chapter = 'health';
			showChapter('routine');
			filters.toggle('routine', -1);
		}

		if (chapter == 'routine') {
			routine.clear();
			showChapter('community');
			// comm.next(-1);
			filters.toggle('community', -1);
			transitionViz('community')
		}
	})

	footer.select('.dir-forward').on('click', () => {
		wrapper.classed('is-past', true).classed('is-visible', false);

		current_chapter = chapter;
		// current_index = index;

		clearTimeout(set_timeout);

		set_timeout = setTimeout(() => {
			rightPanelUpdate(container, panel, current_chapter, doc);
		}, 500)

		if (current_chapter === 'core-viz') core_viz.next(current_index);

		if (current_chapter === 'health') {
			health_globe.next(current_index);
			health_bars.next(current_index);
		}

		if (current_chapter == 'community') {
			comm.next(current_index);
			comm_bars.next(current_index);
		}

		if (current_chapter == 'routine') {
			routine.next(current_index);
		}

		if (chapter == 'aspirations') {
			aspirations.next(current_index);
		}

		filters.toggle(current_chapter, current_index);
		graphic.updateGraphicContent(chapter, current_index);
	});

	footer.select('.dir-back').on('click', () => {
		panel.attr('data-index', current_index - 1);

		wrapper.classed('is-past', true).classed('is-visible', false);

		current_index = current_index - 2;

		clearTimeout(set_timeout);

		set_timeout = setTimeout(() => {
			rightPanelUpdate(container, panel, current_chapter, doc);
		}, 500)

		if (current_chapter === 'core-viz') core_viz.next(current_index);

		if (current_chapter === 'health') {
			health_globe.next(current_index);
			health_bars.next(current_index);
		}

		if (current_chapter == 'community') {
			comm.next(current_index);
			comm_bars.next(current_index);
		};

		if (current_chapter == 'routine') {
			routine.next(current_index);
		}

		if (chapter == 'aspirations') {
			aspirations.next(current_index);
		}

		filters.toggle(current_chapter, current_index);
		graphic.updateGraphicContent(current_chapter, current_index);
	});

	lang.init();

	$('.rp__content--main').scrollTop(0);
}

function showAthlete(athlete, doc = current_doc) {
	changeVisibility([`.graphic__right.athletes`], [true]);
	athletePanelUpdate(athlete, doc);
	aspirations.highlightFeaturedAthlete(athlete);
}

function hideAthletes() {
	changeVisibility([`.graphic__right.athletes`], [false]);
	aspirations.unhighlightFeaturedAthlete();
}

function showChapter(chapter) {
	d3.select(`.graphic__right.${chapter}`).select(`.rp__content`).attr('data-index', 0);
	graphic.updatePanelContent(chapter);
	changeVisibility(['.graphic__right', `.graphic__right.${chapter}`, '.skip-intro', '.bottom-ui'], [false, true, false, false]);

	current_chapter = chapter;
	current_index = 0;

	graphic.updateGraphicContent(current_chapter);

	changeVisibility([`[data-step='${1}']`, `[data-step='${2}']`, `[data-step='${3}']`], [false, false, false], [d3.select('.graphic__text-full'), d3.select('.graphic__text-full'), d3.select('.graphic__text-full')]);

	if (chapter != 'love-hate') {
		love_hate.end();
		track.end();
	}

	if (chapter == 'core-viz') {
		d3.select('.svg__love-hate').selectAll('.bubble')
			.style('visibility', 'visible')
			.transition()
			// .delay((d, i) => i * .2)
			.duration(1000)
			.attr('cx', d => d.x)
			.style('opacity', 1);
	}

	// if (chapter != 'community') {
	// 	comm_bars.end();
	// 	comm.end();
	// }

	// if (chapter != 'aspirations') {
	// 	aspirations.end();
	// 	hideAthletes();
	// }

	// if (chapter == 'community') comm_bars.next(-1);
}

function resetChapter() {

}

function skipStep(index) {
	const container = d3.select(`.graphic__right.${current_chapter}`),
		panel = container.select(`.rp__content`),
		main = panel.select('.rp__content--main'),
		wrapper = main.select('.rp__content--main__wrapper');

	panel.attr('data-index', index + 1);
	wrapper.classed('is-past', true).classed('is-visible', false)

	clearTimeout(set_timeout);

	set_timeout = setTimeout(() => {
		rightPanelUpdate(container, panel, current_chapter, current_doc);
	}, 500)

	filters.toggle(current_chapter, index);
	graphic.updateGraphicContent(current_chapter, index);

	if (current_chapter === 'health') {
		health_globe.next(index);
		health_bars.next(index);
	}
}

function transitionViz(next_chapter) {
	filters.clear();

	//clear current
	if (current_chapter === 'love-hate') {
		love_hate.end();
		love_hate_steps.clear()
	};
	if (current_chapter === 'core-viz') core_viz.clearMass();
	if (current_chapter === 'health') health_globe.clear();
	if (current_chapter === 'community') {
		comm.end();
		comm_bars.end();
	}
	if (current_chapter === 'routine') routine.clear();
	if (current_chapter === 'aspirations') {
		aspirations.end();
		hideAthletes();
	}

	//draw next
	if (next_chapter === 'core-viz') {
		core_viz.moveMass('center');
		// core_viz.updateMassRadius('real');
	}
	if (next_chapter === 'health') health_globe.setup(true);
	if (next_chapter === 'community') {
		comm.next(-1);
		comm_bars.next(-1);
	}
	if (next_chapter === 'routine') routine.transition();
	if (next_chapter === 'aspirations') aspirations.next(-1);
}

function parseContent(content) {
	Object.keys(content).forEach(key => {
		content[key] = content[key] == 'false' ? false : content[key] == 'true' ? true : content[key]
	});

	return content;
}

function parseData(data) {
	data.forEach(d => {
		Object.keys(d).forEach(key => {
			d[key] = isNaN(d[key]) ? d[key] : +d[key]
		})
	})

	return data;
}

function changeVisibility(selector, visible, el = 'd3') {
	if (el != 'd3') {
		selector.forEach((d, i) => el[i].selectAll(selector[i]).classed('is-visible', visible[i]))
	} else {
		selector.forEach((d, i) => d3.selectAll(selector[i]).classed('is-visible', visible[i]))
	}
}

function changeHeader(from, to) {
	changeVisibility([from, to, '.brand-bottom-left'], [false, true, true]);
}

function setStoryLocation(chapter = null, index = null) {
	if (chapter) current_chapter = chapter;
	if (index) current_index = index;
}

function getStoryLocation() {
	return {
		current_chapter,
		current_index,
	}
}

function randomNumber(min, max) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}

function randomNumberDist(num, dists) {
	const output = [];

	dists.forEach(dist => {
		const pct = dist[0],
			count = Math.ceil(num * pct),
			min = dist[1],
			max = dist[2];

		let i = 0;
		while (i < count) {
			output.push(Math.floor(Math.random() * (max - min + 1) + min))
			i++
		}
	})

	return output;
}

function getTransform(transform) {
	const removeStart = transform.substring('translate('.length);
	const removeEnd = removeStart.substring(0, removeStart.length - 1);
	const output = removeEnd.split(',').map(str => +str);
	return output;
}

function getURLparam(key) {
	return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

function isMobile() {
	const windowW = window.innerWidth;
	return windowW < 800 ? true : false;
}

function isTablet() {
	const windowW = window.innerWidth;
	return windowW >= 800 && windowW < 1000 ? true : false;
}

function isDesktop() {
	const windowW = window.innerWidth;
	return windowW >= 1000 ? true : false;
}

function windowWidth() {
	const windowW = window.innerWidth;
	return windowW;
}

export default {
	rightPanelUpdate,
	showChapter,
	showAthlete,
	hideAthletes,
	resetChapter,
	skipStep,
	transitionViz,
	getStoryLocation,
	setStoryLocation,
	parseContent,
	parseData,
	changeVisibility,
	changeHeader,
	randomNumber,
	randomNumberDist,
	getTransform,
	getURLparam,
	isMobile,
	isTablet,
	isDesktop,
	windowWidth
};